// extracted by mini-css-extract-plugin
export default {"bio":"Bio_bio__ZYHiY","biospan":"Bio_biospan__BVTLR","contact":"Bio_contact__b8QGh","element":"Bio_element__pJCIN","mail":"Bio_mail__0HuhZ"};